import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-dashboard-suivi',
  templateUrl: './dashboard-suivi.component.html',
  styleUrls: ['./dashboard-suivi.component.scss'],
})
export class DashboardSuiviComponent implements OnInit {
  filterOn = true;
  confirmBarCode = false;
  scanBarCode = false;
  Code = '';
  dataSchema;
  requestType;
  userSites;
  data;
  selectedOption = 1;
  departColis = [];
  encourColis = [];
  arriveColis = [];

  departColisBackUp = [];
  encourColisBackUp = [];
  arriveColisBackUp = [];

  FilterArrive = '';
  FilterDepart = '';
  FilterReference = '';
  FilterCode = '';
  FilterDate = '';

  slecetedArray = [];
  historyDays = 0;
  displayMode = '';
  userIsAllowedToDelete = false;
  colisToEdit;
  openConfirmDeletePopover;
  openEditPopover;
  isExtern;
  panelOpenState = false;
  reminderFrequencyPerMinute = 1;
  constructor(public generalService: GeneralService) { }
  @ViewChild('code') code;
  showAlertSucc = false;
  showAlertFail = false;
  ngOnInit(): void {
    this.displayMode = localStorage.getItem('PREF_DISPLAY_MODE') || 'cards';
    this.loadData();
    this.generalService.getUserSite().subscribe((res) => {
      this.userSites = res;
      this.userIsAllowedToDelete =
        this.userSites.map((e) => e.UserName).indexOf('chihia') != -1;
    });
  }

  scannedWithPm(event) {
    this.showAlertSucc = false;
    this.showAlertFail = false;
    setTimeout(() => {
      const message = this.code.nativeElement.value;

      this.generalService.getPackageSchema().subscribe((res: any) => {
        this.dataSchema = res;
      });
      this.generalService.getPackage(message).subscribe((res2) => {
        this.data = res2;
        const availableSites = this.userSites.map((e) => e.Site_Code);
        if (
          this.data.Colis[0].Colis_ArriveType > 0 &&
          availableSites.indexOf(this.data.Colis[0].Colis_Depart) != -1
        ) {
          this.requestType = 'Arrivée Externe';
          this.isExtern = true;
        } else if (
          availableSites.indexOf(this.data.Colis[0].Colis_Arrive) != -1
        ) {
          // ARRIVE
          this.requestType = 'ARRIVE';
        } else if (this.data.Colis[0].Colis_DateDepart == null) {
          // DEPART
          this.requestType = 'DEPART';
        } else {
          // ENCOURES
          this.requestType = 'EN COURE';
        }
      });

      this.Code = message;
      this.confirmBarCode = true;
      this.scanBarCode = false;
      this.code.nativeElement.value = '';
    }, 500);
  }
  refocus() {
    const input = document.getElementById('hiddenInput');
    input.focus();
  }
  startListening() {
    this.scanBarCode = true;
    setTimeout(() => {
      this.refocus();
    }, 500);
  }
  submitBarCode() {
    this.confirmBarCode = false;
    if (this.isExtern || this.requestType == 'ARRIVE') {
      this.data.Colis[0].Colis_DateArrive = new Date().toISOString();
    } else if (this.requestType == 'DEPART') {
      this.data.Colis[0].Colis_DateDepart = new Date().toISOString();
    }

    // changing the value of the code  null => qr code result
    this.dataSchema.ColisD[0].Colis_Code = this.Code;
    // sending the package to the api (ColisD)
    this.generalService.postPackage(this.dataSchema).subscribe(
      () => {
        // update the package
        this.generalService.postPackage(this.data).subscribe(
          () => {
            this.confirmBarCode = false;
            this.showAlertSucc = true;
          },
          (err) => {
            this.confirmBarCode = false;
            this.showAlertFail = true;
          }
        );
      },
      (err) => {
        this.confirmBarCode = false;
        this.showAlertFail = true;
      }
    );
  }

  loadData() {
    // loading the data
    this.generalService.getDepartPackages().subscribe((res: any) => {
      this.departColis = res.map((obj) => {
        const thisDate = new Date(obj.Date_Create);
        obj.Date_Create = new Date(
          thisDate.getTime() - thisDate.getTimezoneOffset() * 60000
        );
        const d1: any = new Date();
        const d2: any = new Date(obj.Date_Create);
        const hoursLate = Math.abs(d1 - d2) / 36e5;
        let isLate = hoursLate > 240;
        if (obj.Date_Rappel && new Date() < new Date(obj.Date_Rappel)) {
          isLate = false;
        }
        return { ...obj, isLate };
      });
      setInterval(() => {
        if (!this.openEditPopover) {
          this.colisToEdit =
            this.departColis.find((e) => e.isLate) ||
            this.encourColis.find((e) => e.isLate);
          if (this.colisToEdit) this.toEdit(this.colisToEdit);
        }
      }, 1200000 * this.reminderFrequencyPerMinute);
      this.departColis = this.departColis.filter((e) => e.Colis_Depart != '');
      this.departColisBackUp = this.departColis;
    });

    this.generalService.getEncourPackages().subscribe((res: any) => {
      res.forEach((element) => {
        const thisDate = new Date(element.Date_Create);
        element.Date_Create = new Date(
          thisDate.getTime() - thisDate.getTimezoneOffset() * 60000
        );
      });
      let groupedColiD;
      this.generalService
        .rechercheTable('recherche/tbdata?tablere=apiColisD')
        .subscribe((encour) => {
          groupedColiD = encour.reduce((acc, value) => {
            if (!acc[value.Colis_Code]) {
              acc[value.Colis_Code] = [];
            }
            acc[value.Colis_Code].push(value);
            return acc;
          }, {});
          console.log(groupedColiD);
          res = res.map((colis: any) => {
            const dateDep = new Date(colis.Colis_DateDepart);
            const dateArrivee = new Date(colis.Colis_DateArrive);
            colis.Colis_DateDepart
              ? (colis.Colis_DateDepart = new Date(
                dateDep.getTime() + 1 * 60 * 60 * 1000
              ))
              : colis.Colis_DateDepart;
            colis.Colis_DateArrive
              ? (colis.Colis_DateArrive = new Date(
                dateArrivee.getTime() + 1 * 60 * 60 * 1000
              ))
              : colis.Colis_DateArrive;
            //console.log(colis);
            // const trackDate=new Date(colis.track.Date_Create)
            // colis.track.Date_Create=colis.track.Date_Create=new Date(trackDate.getTime()+ (1*60*60*1000))
            return {
              ...colis,
              track: groupedColiD[colis.Colis_Code + ''],
            };
          });

          res = res.map((obj) => {
            const d1: any = new Date();
            const d2: any = new Date(obj.Colis_DateDepart);
            const hoursLate = Math.abs(d1 - d2) / 36e5;
            let isLate = hoursLate > 240;
            if (obj.Date_Rappel && new Date() < new Date(obj.Date_Rappel)) {
              isLate = false;
            }
            return { ...obj, isLate };
          });
          res.forEach((element) => {
            console.log(element);

            console.log(element.Colis_Code, element.track);
            if (element.track) {
              element.track.forEach((fetchtrack) => {
                const date = new Date(fetchtrack.Date_Create);
                fetchtrack.Date_Create
                  ? (fetchtrack.Date_Create = new Date(
                    date.getTime() + 1 * 60 * 60 * 1000
                  ))
                  : fetchtrack.Date_Create;
              });
            }
          });
          this.encourColis = res;
          console.log(this.encourColis);
          this.encourColisBackUp = res;
        }); // nvm ya3mel appel sys inaccessible lil anydesk
    });

    this.generalService
      .getArrivePackages(this.historyDays)
      .subscribe((arrivee: any) => {
        arrivee.forEach((element) => {
          const dateDep = new Date(element.Colis_DateDepart);
          const dateArrivee = new Date(element.Colis_DateArrive);
          element.Colis_DateDepart
            ? (element.Colis_DateDepart = new Date(
              dateDep.getTime() + 1 * 60 * 60 * 1000
            ))
            : element.Colis_DateDepart;
          element.Colis_DateArrive
            ? (element.Colis_DateArrive = new Date(
              dateArrivee.getTime() + 1 * 60 * 60 * 1000
            ))
            : element.Colis_DateArrive;
          const thisDate = new Date(element.Date_Create);
          element.Date_Create = new Date(
            thisDate.getTime() - thisDate.getTimezoneOffset() * 60000
          );
        });
        this.arriveColis = arrivee;
        this.arriveColisBackUp = arrivee;
        //console.log(this.arriveColisBackUp);
      });
  }
  clearFilter() {
    this.FilterReference = '';
    this.FilterDepart = '';
    this.FilterArrive = '';
    this.FilterCode = '';
    this.FilterDate = '';
    this.updateFilter();
  }
  toggleFilter() {
    this.filterOn = !this.filterOn;
    if (this.filterOn) {
      this.updateFilter();
    } else {
      this.departColis = this.departColisBackUp;
      this.encourColis = this.encourColisBackUp;
      this.arriveColis = this.arriveColisBackUp;
    }
  }
  updateFilter() {
    switch (this.selectedOption) {
      case 1: // depart
        this.departColis = this.departColisBackUp;
        this.departColis = this.departColis.filter((el) =>
          this.filterElements(el)
        );
        break;
      case 2:
        this.encourColis = this.encourColisBackUp;
        this.encourColis = this.encourColis.filter((el) =>
          this.filterElements(el)
        );
        break;
      case 3:
        this.arriveColis = this.arriveColisBackUp;
        this.arriveColis = this.arriveColis.filter((el) =>
          this.filterElements(el)
        );
        break;

      default:
        break;
    }
    this.encourColis;
    this.departColis;
    this.arriveColis;
  }
  filterElements(el) {
    let final = 0;

    if (this.FilterDepart && this.FilterDepart != '' && el.Colis_Depart) {
      final +=
        el.Colis_Depart.includes(this.FilterDepart) ||
          this.FilterDepart.includes(el.Colis_Depart)
          ? 1
          : 0;
    } else if (this.FilterDepart == '') {
      final++;
    }

    if (this.FilterArrive && this.FilterArrive != '' && el.Colis_Arrive) {
      final +=
        el.Colis_Arrive.includes(this.FilterArrive) ||
          this.FilterArrive.includes(el.Colis_Arrive)
          ? 1
          : 0;
    } else if (this.FilterArrive == '') {
      final++;
    }

    if (this.FilterReference && this.FilterReference != '' && el.Colis_Ref) {
      final +=
        el.Colis_Ref.includes(this.FilterReference) ||
          this.FilterReference.includes(el.Colis_Ref)
          ? 1
          : 0;
    } else if (this.FilterReference == '') {
      final++;
    }

    if (this.FilterDate && this.FilterDate != '' && el.Colis_DateDepart) {
      final +=
        new Date(el.Colis_DateDepart).toDateString() ==
          new Date(this.FilterDate).toDateString()
          ? 1
          : 0;
    } else if (this.FilterDate == '' || !el.Colis_DateDepart) {
      final++;
    }

    if (this.FilterCode && this.FilterCode != '' && el.Colis_Code) {
      final +=
        el.Colis_Code.includes(this.FilterCode) ||
          this.FilterCode.includes(el.Colis_Code)
          ? 1
          : 0;
    } else if (this.FilterCode == '') {
      final++;
    }
    return final == 5;
  }
  selectOption(op) {
    this.selectedOption = op;
    this.FilterReference = '';
    this.FilterDepart = '';
    this.FilterArrive = '';
    this.FilterCode = '';
    this.FilterDate = '';
    this.departColis = this.departColisBackUp;
    this.encourColis = this.encourColisBackUp;
    this.arriveColis = this.arriveColisBackUp;
  }
  enAttenteByDate() {
    this.generalService
      .getArrivePackages(this.historyDays)
      .subscribe((res: any) => {
        this.departColis = res;
        this.departColisBackUp = res;
        this.updateFilter();
      });
  }
  encourByDate() {
    this.generalService
      .getArrivePackages(this.historyDays)
      .subscribe((res: any) => {
        this.encourColis = res;
        this.encourColisBackUp = res;
        this.updateFilter();
      });
  }
  arriverByDate() {
    this.generalService
      .getArrivePackages(this.historyDays)
      .subscribe((res: any) => {
        this.arriveColis = res;
        this.arriveColisBackUp = res;
        this.updateFilter();
      });
  }
  changePrefDisplay(mode) {
    this.displayMode = mode;
    localStorage.setItem('PREF_DISPLAY_MODE', mode);
  }
  toDelete(colis) {
    this.colisToEdit = { ...colis };
    this.openConfirmDeletePopover = true;
  }
  toEdit(colis) {
    this.colisToEdit = { ...colis };
    this.openEditPopover = true;
  }
  updateColis() {
    this.generalService
      .getDS('Colis2', this.colisToEdit.Colis_Code)
      .subscribe((res: any) => {
        res.Colis[0].Colis_Ref = this.colisToEdit.Colis_Ref;
        res.Colis[0].Colis_Arrive = this.colisToEdit.Colis_Arrive;
        res.Colis[0].Colis_Texte = this.colisToEdit.Colis_Texte;
        res.Colis[0].Date_Rappel = this.colisToEdit.Date_Rappel;
        res.Colis[0].Colis_Rappel = this.colisToEdit.Colis_Rappel;
        this.generalService.postDs(res).subscribe(
          () => {
            this.generalService.dialogSuccess('Elément Modifier', true);
            this.loadData();
            this.clearFilter();
          },
          (err) => {
            this.generalService.dialogSuccess('Elément non Modifier', false);
          }
        );
        this.openEditPopover = false;
      });
  }
  deleteColis() {
    this.openConfirmDeletePopover = false;
    this.generalService.delete(this.colisToEdit.Colis_Code, 'Colis2').subscribe(
      (data) => {
        this.generalService.dialogSuccess('Elément supprimer', true);
        this.loadData();
        this.clearFilter();
      },
      (error) => {
        this.generalService.dialogSuccess('Elément non supprimé', false);
      }
    );
  }
  getLatePackages(arr) {
    return arr.filter((e) => e.isLate).length;
  }
  closeEdit() {
    this.openEditPopover = false;
    setTimeout(() => {
      if (!this.openEditPopover) {
        this.colisToEdit =
          this.departColis.find((e) => e.isLate) ||
          this.encourColis.find((e) => e.isLate);
        if (this.colisToEdit) this.toEdit(this.colisToEdit);
      }
    }, 1200000 * this.reminderFrequencyPerMinute);
  }
  changeArriveType(e) {
    this.colisToEdit.Colis_ArriveType = e.checked ? 1 : 0;
  }
}
